import { render, staticRenderFns } from "./ReviewProgress.vue?vue&type=template&id=716f20c8&scoped=true"
import script from "./ReviewProgress.vue?vue&type=script&lang=js"
export * from "./ReviewProgress.vue?vue&type=script&lang=js"
import style0 from "./ReviewProgress.vue?vue&type=style&index=0&id=716f20c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716f20c8",
  null
  
)

export default component.exports